var _defs, _rect, _text, _line, _line2, _g, _g2, _g3, _g4, _g5, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg8Timeline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 760 220",
    xmlns: "http://www.w3.org/2000/svg",
    width: 760,
    height: 220,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n    @keyframes tl-step{0%,100%{opacity:.3}50%{opacity:1}}\n    @keyframes tl-dot{0%,100%{r:6;opacity:.5}50%{r:8;opacity:1}}\n    @keyframes progress-fill{from{width:0}to{width:680px}}\n    .ts1{animation:tl-step 8s ease-in-out infinite 0s}\n    .ts2{animation:tl-step 8s ease-in-out infinite 1.6s}\n    .ts3{animation:tl-step 8s ease-in-out infinite 3.2s}\n    .ts4{animation:tl-step 8s ease-in-out infinite 4.8s}\n    .ts5{animation:tl-step 8s ease-in-out infinite 6.4s}\n    .td1{animation:tl-dot 8s ease-in-out infinite 0s}\n    .td2{animation:tl-dot 8s ease-in-out infinite 1.6s}\n    .td3{animation:tl-dot 8s ease-in-out infinite 3.2s}\n    .td4{animation:tl-dot 8s ease-in-out infinite 4.8s}\n    .td5{animation:tl-dot 8s ease-in-out infinite 6.4s}\n  "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tl-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#060912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#06091a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tl-line",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3b82f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f472b6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tl-glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "b"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "b"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 760,
    height: 220,
    fill: "url(#tl-bg)",
    rx: 20
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 380,
    y: 26,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "JetBrains Mono",
    fontSize: 10,
    letterSpacing: 2
  }, "FULL DAILY CYCLE \u2014 MIDNIGHT TO MIDNIGHT")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 118,
    x2: 720,
    y2: 118,
    stroke: "#1e293b",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 118,
    x2: 720,
    y2: 118,
    stroke: "url(#tl-line)",
    strokeWidth: 2,
    opacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ts1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "td1",
    cx: 80,
    cy: 118,
    r: 6,
    fill: "#3b82f6",
    filter: "url(#tl-glow)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 112,
    x2: 80,
    y2: 72,
    stroke: "#3b82f6",
    strokeWidth: 1,
    strokeDasharray: "3,3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 44,
    width: 104,
    height: 32,
    rx: 6,
    fill: "#0a1628",
    stroke: "#3b82f6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 59,
    textAnchor: "middle",
    fill: "#3b82f6",
    fontFamily: "JetBrains Mono",
    fontSize: 8,
    fontWeight: 700
  }, "12:00 AM"), /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 71,
    textAnchor: "middle",
    fill: "#60a5fa",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "Stats Job Runs"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "ts2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "td2",
    cx: 210,
    cy: 118,
    r: 6,
    fill: "#a78bfa",
    filter: "url(#tl-glow)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 124,
    x2: 210,
    y2: 164,
    stroke: "#a78bfa",
    strokeWidth: 1,
    strokeDasharray: "3,3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 152,
    width: 115,
    height: 32,
    rx: 6,
    fill: "#0a1628",
    stroke: "#a78bfa",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 167,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontFamily: "JetBrains Mono",
    fontSize: 8,
    fontWeight: 700
  }, "1:00 AM"), /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 179,
    textAnchor: "middle",
    fill: "#c4b5fd",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "Prep Messages"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "ts3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "td3",
    cx: 380,
    cy: 118,
    r: 8,
    fill: "#fb923c",
    filter: "url(#tl-glow)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 112,
    x2: 380,
    y2: 72,
    stroke: "#fb923c",
    strokeWidth: 1,
    strokeDasharray: "3,3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 44,
    width: 124,
    height: 32,
    rx: 6,
    fill: "#0a1628",
    stroke: "#fb923c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 380,
    y: 59,
    textAnchor: "middle",
    fill: "#fb923c",
    fontFamily: "JetBrains Mono",
    fontSize: 8,
    fontWeight: 700
  }, "EVERY HOUR"), /*#__PURE__*/React.createElement("text", {
    x: 380,
    y: 71,
    textAnchor: "middle",
    fill: "#fdba74",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "Cron Schedules"), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 118,
    r: 3,
    fill: "#fb923c",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365,
    cy: 118,
    r: 3,
    fill: "#fb923c",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 118,
    r: 3,
    fill: "#fb923c",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 118,
    r: 3,
    fill: "#fb923c",
    opacity: 0.4
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "ts4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "td4",
    cx: 540,
    cy: 118,
    r: 6,
    fill: "#34d399",
    filter: "url(#tl-glow)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 124,
    x2: 540,
    y2: 164,
    stroke: "#34d399",
    strokeWidth: 1,
    strokeDasharray: "3,3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 152,
    width: 136,
    height: 32,
    rx: 6,
    fill: "#0a1628",
    stroke: "#34d399",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 167,
    textAnchor: "middle",
    fill: "#34d399",
    fontFamily: "JetBrains Mono",
    fontSize: 8,
    fontWeight: 700
  }, "PEAK HOUR"), /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 179,
    textAnchor: "middle",
    fill: "#6ee7b7",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "Jobs Queued"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "ts5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "td5",
    cx: 690,
    cy: 118,
    r: 6,
    fill: "#f472b6",
    filter: "url(#tl-glow)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 690,
    y1: 112,
    x2: 690,
    y2: 72,
    stroke: "#f472b6",
    strokeWidth: 1,
    strokeDasharray: "3,3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634,
    y: 44,
    width: 96,
    height: 32,
    rx: 6,
    fill: "#0a1628",
    stroke: "#f472b6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 682,
    y: 59,
    textAnchor: "middle",
    fill: "#f472b6",
    fontFamily: "JetBrains Mono",
    fontSize: 8,
    fontWeight: 700
  }, "INSTANT"), /*#__PURE__*/React.createElement("text", {
    x: 682,
    y: 71,
    textAnchor: "middle",
    fill: "#f9a8d4",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "\u2713 Delivered"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 380,
    y: 206,
    textAnchor: "middle",
    fill: "#1e293b",
    fontFamily: "JetBrains Mono",
    fontSize: 9
  }, "Fully automated \u2014 zero manual intervention required")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg8Timeline);
export default __webpack_public_path__ + "static/media/svg8-timeline.dd0241742d7f03c1d4bb8d005a7084be.svg";
export { ForwardRef as ReactComponent };